import React from 'react';

// Actions
import { authorizeEmail } from '@/redux/modules/omni-risk-profiles';

// Components
import { SendQuestionnaireBody } from './components/SendQuestionnaireBody';
import { withErrorBoundary } from '@/views/components/errors';

// Enums
import { OmniRiskProfileEmailTemplate, OmniRiskProfileStatus } from '@/enums/OmniRiskProfiles';

// Libraries
import { Dispatch } from '@/redux';
import { useDispatch } from 'react-redux';

// Types
import { FormattedFullOmniRiskProfile } from '@/types/risk-profiles/omni/full-omni-risk-profile';

// Utils
import notification from '@/utils/notification';
import { formatMessage } from '@/utils/i18n';

type Props = {
  hasEnforcedContactEmail: boolean;
  initialEmail: string;
  riskProfile: FormattedFullOmniRiskProfile;
};

const SendReviewQuestionnaire: React.FC<Props> = ({ hasEnforcedContactEmail, initialEmail, riskProfile }) => {
  const dispatch = useDispatch<Dispatch>();
  const { emails = [], status } = riskProfile;
  const sharedEmails = status === OmniRiskProfileStatus.ClientReview ? emails : [];

  const handleAuthorizeEmail = async (email: string) => {
    try {
      await dispatch(authorizeEmail(email, riskProfile, OmniRiskProfileEmailTemplate.RefreshReview));
      notification.success(
        formatMessage('RiskProfileModal.SendQuestionnaire.AuthorizedNotificationBody'),
        formatMessage('RiskProfileModal.SendQuestionnaire.AuthorizedNotificationTitle'),
      );
    } catch (error) {
      notification.error(formatMessage('RiskProfileModal.SendQuestionnaire.SendEmailError'));
    }
  };

  return (
    <SendQuestionnaireBody
      authorizeEmail={handleAuthorizeEmail}
      className="is-reviewing"
      hasEnforcedContactEmail={hasEnforcedContactEmail}
      initialEmail={initialEmail}
      riskProfile={riskProfile}
      sharedEmails={sharedEmails}
      showRiskProfileDetails
    />
  );
};

export default withErrorBoundary(SendReviewQuestionnaire);
